function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { RoomType } from "../RoomType";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { PLACEHOLDERS } from "./constants";
export var Component = function Component(_ref) {
  var isShowingPlaceholder = _ref.isShowingPlaceholder,
      roomTypes = _ref.roomTypes;
  var roomTypesToMap = isShowingPlaceholder && roomTypes.length === 0 ? PLACEHOLDERS : roomTypes;
  return React.createElement(Fragment, null, roomTypesToMap.map(function (roomType, index) {
    return React.createElement(RoomType, _extends({
      isShowingPlaceholder: isShowingPlaceholder,
      key: buildKeyFromStrings(roomType.name, index)
    }, roomType));
  }));
};
Component.displayName = 'RoomTypes';
Component.defaultProps = {
  isShowingPlaceholder: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  isShowingPlaceholder: PropTypes.bool,
  roomTypes: PropTypes.arrayOf(PropTypes.object).isRequired
} : {};